export default __webpack_public_path__ + "static/kiln-1-fdd8a8571f91d3136b7db07f8ce2174e.jpg";